import { useMemo } from 'react'

const useReportedYears = (months: Date[]): number[] => {
  return useMemo(() => {
    if (!months || months.length === 0) return []
    return months.reduce((prev: number[], month) => {
      const year = month.getFullYear()
      if (prev.includes(year)) return prev
      return [...prev, year]
    }, [])
  }, [months])
}

export default useReportedYears
